import router from '../../app/router'

import VipCard from './pages/home/index'
import VipExplain from './pages/home/vip-explain'
import huaweiVIP from './pages/huaweiVIP/index'
import confirmOpen from './pages/huaweiVIP/confirmOpen.vue'
import VIPInstruction from './pages/huaweiVIP/VIPInstruction.vue'
import goldFree from './pages/goldFree/index.vue'
import vipPriority from './pages/goldFree/vipPriority.vue'
import goldSale from './pages/goldSale/index.vue'
import goldSaleOpen from './pages/goldSale/confirmOpen.vue'
import goldInstruction from './pages/goldSale/instruction.vue'
import receiveFree from './pages/receiveFree/index.vue'
import sikuGold from './pages/sikuGold/index.vue'
import checkPriority from './pages/sikuGold/checkPriority.vue'
import guangdaCard from './pages/guangdaCard/index.vue'

const routes = [
  {
    path: '/vipCard/home',
    name: 'vipCard/home',
    component: VipCard,
    meta: {
      auth: true,
      title: '我的会员'
    }
  },
  {
    path: '/vipCard/explain',
    name: 'vipCard/explain',
    component: VipExplain
  },
  //华为钻石会员199/年 活动
  {
    path: '/vipCard/huaweiVIP',
    name: 'vipCard/huaweiVIP',
    component: huaweiVIP,
    meta: {
      auth: true,
      authConfig: {
        gtWechatAuth: true
      }
    }
  },
  {
    path: '/vipCard/confirmOpen',
    name: 'vipCard/confirmOpen',
    component: confirmOpen,
    meta: {
      auth: true,
      authConfig: {
        gtWechatAuth: true,
        hbWechatOpenid: true
      }
    }
  },
  {
    path: '/vipCard/VIPInstruction',
    name: 'vipCard/VIPInstruction',
    component: VIPInstruction
  },
  //黄金会员免费送活动
  {
    path: '/vipCard/goldFree',
    name: 'vipCard/goldFree',
    component: goldFree
  },
  {
    path: '/vipCard/vipPriority',
    name: 'vipCard/vipPriority',
    component: vipPriority
  },
  //买黄金会员49/年 活动
  {
    path: '/vipCard/goldSale',
    name: 'vipCard/goldSale',
    component: goldSale
  },
  {
    path: '/vipCard/goldSaleOpen',
    name: 'vipCard/goldSaleOpen',
    component: goldSaleOpen,
    meta: {
      auth: true,
      authConfig: {
        gtWechatAuth: true,
        hbWechatOpenid: true
      }
    }
  },
  {
    path: '/vipCard/goldInstruction',
    name: 'vipCard/goldInstruction',
    component: goldInstruction
  },
  {
    path: '/vipCard/receiveFree',
    name: 'vipCard/receiveFree',
    component: receiveFree,
    meta: {
      title: '高铁管家黄金会员权益免费领',
      authConfig: {
        gtWechatAuth: true
      }
    }
  },
  //寺库黄金会员
  {
    path: '/vipCard/sikuGold',
    name: 'vipCard/sikuGold',
    component: sikuGold,
    meta: {
      title: '免费领取高铁黄金会员'
    }
  },
  {
    path: '/vipCard/checkPriority',
    name: 'vipCard/checkPriority',
    component: checkPriority,
    meta: {
      title: '免费领取高铁黄金会员'
    }
  },
  {
    path: '/vipCard/guangdaCard',
    name: 'vipCard/guangdaCard',
    component: guangdaCard,
    meta: {
      title: '光大信用卡白金会员'
    }
  }
]

router.addRoutes(routes)

export default router



// WEBPACK FOOTER //
// ./src/projects/vipCard/router.js